import React, { FunctionComponent } from "react";

import { useLanguage } from "../../../i18n/useLanguage";
import { useDealerAccountInfo } from "../../../stores/hooks/useDealerAccountInfo";

export const CartPrintLegalInfo: FunctionComponent = () => {
  const [language] = useLanguage();
  const { dealerCarousels, legalFooter } = useDealerAccountInfo();
  const src =
    dealerCarousels.order_summary[0]?.imageURL[language] ||
    dealerCarousels.order_summary[0]?.imageURL["en"];
  const text = legalFooter[language];
  return (
    text && (
      <section className="border border-edge rounded-section p-4 print:text-[0.4rem] print:leading-3">
        {src && <img alt="legal footer" src={src} />}
        <p>{text}</p>
      </section>
    )
  );
};
